import { render, staticRenderFns } from "./SocketRooms.vue?vue&type=template&id=5631eb89&scoped=true"
import script from "./SocketRooms.vue?vue&type=script&lang=js"
export * from "./SocketRooms.vue?vue&type=script&lang=js"
import style0 from "./SocketRooms.vue?vue&type=style&index=0&id=5631eb89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631eb89",
  null
  
)

export default component.exports